import React, { useState } from "react";
import logo from "../../assets/logo.png";
import styles from "./Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import Auth from "../../utils/api/Auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FixedAgent from "../../utils/api/FixedAgent";

function SignUp() {
  const [input, setInput] = useState({
    email: "",
    fullname: "",
    password: "",
    businessName: "",
    phone: "",
    confirmPassword: "",
    accountType: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const submitLoginHandler = async (e) => {
    e.preventDefault();
    if (input.password !== input.confirmPassword) {
      alert("Password and Confirm Password must match.");
      return;
    }
    setIsLoading(true);
    try {
      const registerRes = await (input.accountType === "DISTRIBUTOR"
        ? Auth.registerUserHandler({
            fullname: input.fullname,
            email: input.email,
            password: input.password,
            phone_no: input.phone,
            business_name: input.businessName,
          })
        : Auth.registerFixedAgentHandler({
            fullname: input.fullname,
            email: input.email,
            password: input.password,
            phone_no: input.phone,
            business_name: input.businessName,
          }));

      const message = `Welcome ${input.fullname}! Your AgentPro account has been created for ${input.businessName}. Login with email: ${input.email} and pass: ${input.password} to start managing vehicle papers efficiently.`;

      const smsRes = await FixedAgent.sendSms({
        recipients: input.phone.startsWith("0")
          ? "234" + input.phone.slice(1)
          : input.phone,
        message,
      });
      navigate("/login");
      setIsLoading(false);
      return { registerRes, smsRes };
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  return (
    <div className={styles.main}>
      <ToastContainer />
      <div className={styles.main_header}>
        <div>
          <p>Welcome! Register to transform your business.</p>
        </div>
      </div>

      <div className={styles.main_content}>
        <div className={styles.main_content_logo}>
          <img src={logo} alt="logo" />
        </div>
        <form
          onSubmit={submitLoginHandler}
          className={styles.main_content_inner_form}
        >
          <select
            className={styles.select_field}
            name="accountType"
            value={input.accountType}
            required
            onChange={handleInputChange}
          >
            <option value="">Choose Account Type</option>
            <option value="DISTRIBUTOR">Distributor</option>
            <option value="FixedAgent">Fixed Agent</option>
          </select>
          <input
            type="text"
            name="fullname"
            required
            value={input.fullname}
            placeholder="Fullname"
            className={styles.input_field}
            onChange={handleInputChange}
          />
          <input
            type="email"
            required
            name="email"
            value={input.email}
            placeholder="Email"
            className={styles.input_field}
            onChange={handleInputChange}
          />
          <input
            required
            type="text"
            value={input.businessName}
            name="businessName"
            placeholder="Business Name"
            className={styles.input_field}
            onChange={handleInputChange}
          />
          <input
            type="tel"
            required
            name="phone"
            value={input.phone}
            placeholder="Phone"
            className={styles.input_field}
            onChange={handleInputChange}
          />

          <input
            type="password"
            required
            value={input.password}
            name="password"
            placeholder="Password"
            className={styles.input_field}
            onChange={handleInputChange}
          />

          <input
            value={input.confirmPassword}
            type="password"
            required
            name="confirmPassword"
            placeholder="Confirm Password"
            className={styles.input_field}
            onChange={handleInputChange}
          />

          <button
            type="submit"
            disabled={isLoading}
            className={styles.login_button}
            style={{
              cursor: isLoading ? "not-allowed" : "default",
              opacity: isLoading ? 0.5 : 1,
            }}
          >
            {isLoading ? `Loading...` : `Register`}
          </button>

          <Link to="/login" className={styles.register_link}>
            Already Registered - Login
          </Link>
        </form>
      </div>
    </div>
  );
}

export default SignUp;
